module.exports = __webpack_public_path__ + "static/img/platform-6.d80a43be.png";